export default "__VITE_ASSET__BCeROEdo__"